import {
  AccountsAgencyPartnerChoices,
  PublisherChoicesEnum,
} from "../graphql/generated";
import { PublisherEnum } from "../graphqlExternal/generated";

export const publisherMap = (
  partner: AccountsAgencyPartnerChoices
): PublisherEnum => {
  switch (partner) {
    case AccountsAgencyPartnerChoices.Arena:
      return PublisherEnum.Arena;
    case AccountsAgencyPartnerChoices.IrishTimes:
      return PublisherEnum.IrishTimes;
    case AccountsAgencyPartnerChoices.NewsUk:
      return PublisherEnum.NewsUk;
    default:
      return PublisherEnum.Demo;
  }
};

export const publisherMapChoice = (
  publisher: PublisherEnum
): PublisherChoicesEnum => {
  switch (publisher) {
    case PublisherEnum.Arena:
      return PublisherChoicesEnum.Arena;
    case PublisherEnum.IrishTimes:
      return PublisherChoicesEnum.IrishTimes;
    case PublisherEnum.NewsUk:
      return PublisherChoicesEnum.NewsUk;

    default:
      return PublisherChoicesEnum.NewsUk;
  }
};
